export const ProductType = [
  {
    value: 1,
    label: 'Căn hộ'
  },
  {
    value: 2,
    label: 'Tòa nhà'
  },
  {
    value: 3,
    label: 'Nhà đất'
  },
  {
    value: 4,
    label: 'Đất nền'
  }
]

export const SUB_PRODUCT_TYPE = {
  APARTMENT: [
    { value: 1, label: 'Căn hộ chung cư' },
    { value: 2, label: 'Căn hộ Penthouse' },
    { value: 3, label: 'Căn hộ Duplex' },
    { value: 4, label: 'Căn hộ Studio' },
    { value: 5, label: 'Căn hộ Officetel' },
    { value: 6, label: 'Căn hộ Dual Key' },
    { value: 7, label: 'Căn hộ Sân Vườn' },
    { value: 8, label: 'Căn hộ khác' }
  ],
  BUILDING: [
    { value: 30, label: 'Sàn văn phòng' },
    { value: 31, label: 'Sàn thương mại' },
    { value: 32, label: 'Toà văn phòng' },
    { value: 33, label: 'Toà khách sạn' },
    { value: 34, label: 'Toà nhà hỗn hợp' },
    { value: 35, label: 'Toà nhà khác' }
  ],
  REAL_ESTATE: [
    { value: 40, label: 'Nhà ngõ' },
    { value: 41, label: 'Nhà mặt phố' },
    { value: 42, label: 'Biệt thự' },
    { value: 43, label: 'Liền kề' },
    { value: 44, label: 'Shophouse' },
    { value: 45, label: 'Nhà đất khác' }
  ],
  GROUND: [
    { value: 20, label: 'Đất ở' },
    { value: 26, label: 'Đất dự án' },
    { value: 21, label: 'Đất khu công nghiệp' },
    { value: 22, label: 'Nhà xưởng' },
    { value: 23, label: 'Kho/Bãi' },
    { value: 24, label: 'Đất kinh doanh dịch vụ' },
    { value: 25, label: 'Đất nền khác' },
    
  ]
}

export const SubProductType = {
  APARTMENT: [
    'Căn hộ chung cư',
    'Căn hộ Penthouse',
    'Căn hộ Duplex',
    'Căn hộ Studio',
    'Căn hộ Officetel',
    'Căn hộ Dual Key',
    'Căn hộ Sân Vườn',
    'Căn hộ khác'
  ],
  BUILDING: [
    'Sàn văn phòng',
    'Sàn thương mại',
    'Toà văn phòng',
    'Toà khách sạn',
    'Toà nhà hỗn hợp',
    'Toà nhà khác'
  ],
  REAL_ESTATE: [
    'Nhà ngõ',
    'Nhà mặt phố',
    'Liền kề',
    'Biệt thự',
    'Shophouse',
    'Nhà đất khác'
  ],
  GROUND: [
    'Đất ở',
    'Đất dự án',
    'Đất khu công nghiệp',
    'Nhà xưởng',
    'Kho/Bãi',
    'Đất kinh doanh dịch vụ',
    'Đất nền khác',
  ]
}

export const RealEstateType = ['Căn hộ', 'Nhà đất', 'Tòa nhà']

export const getSubProductType = (value) => {
  switch (value) {
    case 1:
      return SUB_PRODUCT_TYPE.APARTMENT
    case 2:
      return SUB_PRODUCT_TYPE.BUILDING
    case 3:
      return SUB_PRODUCT_TYPE.REAL_ESTATE
    case 4:
      return SUB_PRODUCT_TYPE.GROUND
    default:
      return []
  }
}

export const statusList = [
  {
    value: 1,
    label: 'Đã xử lý',
    name: 'Đã xử lý',
    color: 'green'
  },
  {
    value: 2,
    label: 'Chưa xử lý',
    name: 'Chưa xử lý',
    color: 'yellow'
  }
]

export const status = [
  {
    value: 1,
    label: 'Mới'
  },
  {
    value: 2,
    label: 'Hoàn hảo'
  },
  {
    value: 3,
    label: 'Phương án'
  },
  {
    value: 4,
    label: 'Tạm dừng'
  },
  {
    value: 5,
    label: 'Đã chốt'
  },
  {
    value: 6,
    label: 'Loại'
  },
  {
    value: 7,
    label: 'Trùng tin'
  }
]

export const APARTMENT_TYPE = [
  {
    value: 1,
    label: 'Góc'
  },
  {
    value: 2,
    label: 'Thường'
  }
]
export const ApartmentType = [
  {
    value: 'Thường',
    label: 'Thường'
  },
  {
    value: 'Góc',
    label: 'Góc'
  }
]

export const RoleList = [
  {
    value: 'ADMIN',
    label: 'Admin'
  },
  {
    value: 'SUB_ADMIN',
    label: 'Sub Admin'
  },
  {
    value: 'MANAGER',
    label: 'Quản lý'
  },
  {
    value: 'STAFF',
    label: 'Nhân viên'
  },
  {
    value: 'CUSTOMER',
    label: 'Khách hàng'
  }
]

export const OPTIONS_ROLE_USER = [
  {
    value: 'ADMIN',
    name: 'Admin'
  },
  {
    value: 'CEO',
    name: 'CEO'
  },
  {
    value: 'DIRECTOR',
    name: 'Giám đốc'
  },
  {
    value: 'SALE_MANAGER',
    name: 'Quản lý sản phẩm'
  },
  {
    value: 'SALE',
    name: 'Nhân viên'
  },
  {
    value: 'CUSTOMER',
    name: 'Khách hàng'
  },
  {
    value: 'COLLAB',
    name: 'Cộng tác viên'
  },
  {
    value: 'SUB_ADMIN',
    name: 'Sub Admin'
  },
]

export const BedroomNumber = [
  {
    label: '1 PN',
    value: '1.0'
  },
  {
    label: '1 PN + 1',
    value: '1.5'
  },
  {
    label: '2 PN',
    value: '2.0'
  },
  {
    label: '2 PN + 1',
    value: '2.5'
  },
  {
    label: '3 PN',
    value: '3.0'
  },
  {
    label: '3 PN + 1',
    value: '3.5'
  },
  {
    label: '4 PN',
    value: '4.0'
  },
  {
    label: '5 PN',
    value: '5.0'
  },
  {
    label: '6 PN',
    value: '6.0'
  }
]

export const LabelType = [
  {
    value: 1,
    label: 'Thuê'
  },
  {
    value: 2,
    label: 'Bán'
  },
  // {
  //   value: 3,
  //   label: 'Tìm thuê'
  // },
  // {
  //   value: 4,
  //   label: 'Tìm mua'
  // },
  // {
  //   value: 5,
  //   label: 'Dự án'
  // }
]

export const WCNumber = [1, 2, 3, 4, 5]

export const BALCONY_DIRECTION = [
  { value: 1, label: 'Đông' },
  { value: 2, label: 'Tây' },
  { value: 3, label: 'Nam' },
  { value: 4, label: 'Bắc' },
  { value: 5, label: 'Đông Nam' },
  { value: 6, label: 'Đông Bắc' },
  { value: 7, label: 'Tây Nam' },
  { value: 8, label: 'Tây Bắc' },
  { value: 9, label: 'Đông Nam - Đông Bắc' },
  { value: 10, label: 'Đông Nam - Tây Nam' },
  { value: 11, label: 'Đông Bắc - Tây Bắc' },
  { value: 12, label: 'Tây Bắc - Tây Nam' }
]

export const BalconyDirection = [
  'Đông',
  'Tây',
  'Nam',
  'Bắc',
  'Đông Nam',
  'Đông Bắc',
  'Tây Nam',
  'Tây Bắc',
  'Tây Bắc - Tây Nam',
  'Đông Nam - Đông Bắc',
  'Đông Bắc - Tây Bắc',
  'Đông Nam - Tây Nam'
]

export const POLICY_DOCUMENT = [
  { value: 1, label: 'Sổ hồng' },
  { value: 2, label: 'Sổ hồng 50 năm' },
  { value: 3, label: 'Hợp đồng mua bán' },
  { value: 4, label: 'Sổ đỏ' },
  { value: 5, label: 'Giấy tờ khác' },
  { value: 6, label: 'Chưa có sổ' },
  // { value: 7, label: 'Hợp đồng mua bán' }, // Sửa lỗi: "Hơp" -> "Hợp"
  { value: 7, label: 'Chưa có hợp đồng mua bán' },
  { value: 8, label: 'Hợp đồng 50 năm' } // Sửa lỗi: "Hơp" -> "Hợp"
]

export const PolicyDocumnet = [
  'Sổ hồng',
  'Sổ hồng 50 năm',
  'Hợp đồng mua bán',
  'Sổ đỏ',
  'Giấy tờ khác',
  'Chưa có sổ',
  // 'Hơp đồng mua bán',
  'Chưa có hợp đồng mua bán',
  'Hơp đồng 50 năm'
]

export const Unit = ['Triệu đồng', 'Tỷ đồng']

export const PROCCESS_TRANFER = [
  { value: 1, label: 'Bao phí' },
  { value: 2, label: 'Không bao phí' },
  { value: 3, label: '50/50' },
  { value: 4, label: 'Thương lượng' }
]

export const ProcessTranfer = [
  'Bao phí',
  '50/50',
  'Không bao phí',
  'Thương lượng'
]
export const FURNITURE_TYPE = [
  { value: 1, label: 'Thô' },
  { value: 2, label: 'Nguyên bản' },
  { value: 3, label: 'Cơ bản' },
  { value: 4, label: 'Full' }
]

export const FurnitureType = ['Thô', 'Nguyên bản', 'Cơ bản', 'Full']

export const SecurityType = ['Tin bảo mật', 'Tin kết hợp']

export const SECURITY_TYPE = [
  { value: 1, label: 'Tin bảo mật' },
  { value: 2, label: 'Tin kết hợp' }
  // { value: 3, label: 'Tin chính chủ' }
]

export const FieldList = [
  {
    field: 'product_type',
    label: 'Cập nhật loại BĐS từ'
  },
  {
    field: 'city_id',
    label: 'Cập nhật khu vực từ'
  },
  {
    field: 'district_id',
    label: 'Cập nhật Quận/Huyện từ'
  },
  {
    field: 'town_id',
    label: 'Cập nhật Xã/Phường từ'
  },
  {
    field: 'street',
    label: 'Cập nhật Đường/phố từ'
  },
  {
    field: 'alley',
    label: 'Cập nhật Ngõ/hẻm từ'
  },
  {
    field: 'area',
    label: 'Cập nhật diện tích đất từ'
  },
  {
    field: 'area_outsize',
    label: 'Cập nhật mặt tiền từ'
  },
  {
    field: 'length',
    label: 'Cập nhật chiều dài mảnh đất từ'
  },
  {
    field: 'direction',
    label: 'Cập nhật hướng từ'
  },
  {
    field: 'area_for_building',
    label: 'Cập nhật diện tích xây dựng từ'
  },
  {
    field: 'number_of_floor',
    label: 'Cập nhật số tầng từ'
  },
  {
    field: 'cost',
    label: 'Cập nhật phí từ'
  },
  {
    field: 'project_name',
    label: 'Cập nhật tên dự án từ'
  },
  {
    field: 'code',
    label: 'Cập nhật mã căn hộ từ'
  },
  {
    field: 'building',
    label: 'Cập nhật Tòa/khu từ'
  },
  {
    field: 'floor',
    label: 'Cập nhật tầng/dãy từ'
  },
  {
    field: 'acreage',
    label: 'Cập nhật diện tích từ'
  },
  {
    field: 'number_of_bedrooms',
    label: 'Cập nhật số phòng ngủ từ'
  },
  {
    field: 'number_of_wc',
    label: 'Cập nhật số WC từ'
  },
  {
    field: 'balcony_direction',
    label: 'Cập nhật hướng ban công từ'
  },
  {
    field: 'apartment_location',
    label: 'Cập nhật vị trí căn từ'
  },
  {
    field: 'legal',
    label: 'Cập nhật giấy tờ pháp lý từ'
  },
  {
    field: 'price',
    label: 'Cập nhật giá từ'
  },
  {
    field: 'unit',
    label: 'Cập nhật đơn vị (tiền tệ) từ'
  },
  {
    field: 'procedure',
    label: 'Cập nhật thủ tục chuyển nhượng từ'
  },
  {
    field: 'furniture',
    label: 'Cập nhật nội thất từ'
  },
  {
    field: 'security',
    label: 'Cập nhật bảo mật thông tin từ'
  },
  {
    field: 'name',
    label: 'Cập nhật tên chủ nhà từ'
  },
  {
    field: 'phone_number',
    label: 'Cập nhật số điện thoại liên hệ từ'
  },
  {
    field: 'description',
    label: 'Cập nhật nội dung từ'
  },
  {
    field: 'department_id',
    label: 'Cập nhật sàn từ'
  },
  {
    field: 'title',
    label: 'Cập nhật tiêu đề từ'
  },
  {
    field: 'label',
    label: 'Cập nhật loại giao dịch từ'
  },
  {
    field: 'status',
    label: 'Cập nhật hiện trạng từ'
  },
  {
    field: 'is_com',
    label: 'Cập nhật trạng thái tin từ'
  },
  {
    field: 'number_of_rooms',
    label: 'Cập nhật số căn từ'
  },
  {
    field: 'is_public',
    label: 'Cập nhật'
  },
  {
    field: 'manager_product_name',
    label: 'Cập nhật người quản lý tin từ'
  }
]
export const LINK_API = process.env.REACT_APP_API_URL
export const LINK_API_IMAGE = `${LINK_API}/api/v1/upload`
